import { defineComponent as _defineComponent } from 'vue'
import useHttpRequest from "@/composables/use-http-request";
import { MessageBox } from "element-ui";
import store from "@/store";
import { useRouter } from "vue-router/composables";

import HomeIcon from "@/assets/icons/svg/home.icon.svg";
import FoldersIcon from "@/assets/icons/svg/folders.icon.svg";
import VideoIcon from "@/assets/icons/svg/video.icon.svg";
import ClockIcon from "@/assets/icons/svg/clock.icon.svg";
import BookOpenIcon from "@/assets/icons/svg/book-open.icon.svg";
import GraduationCapIcon from "@/assets/icons/svg/graduation-cap.icon.svg";
import HourglassIcon from "@/assets/icons/svg/hourglass.icon.svg";
import CoinsIcon from "@/assets/icons/svg/coins.icon.svg";
import TelevisionIcon from "@/assets/icons/svg/television.icon.svg";
import CheckboxIcon from "@/assets/icons/svg/checkbox.icon.svg";
import MessageIcon from "@/assets/icons/svg/message.icon.svg";
import EditIcon from "@/assets/icons/svg/edit.icon.svg";
import SettingsIcon from "@/assets/icons/svg/settings.icon.svg";
import LogoutIcon from "@/assets/icons/svg/logout.icon.svg";


export default /*#__PURE__*/_defineComponent({
  __name: 'side-navbar-component',
  setup(__props) {

const router = useRouter();

const closeNav = () => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  document.getElementById("mySidenav")!.style.width = "0";
};

const logOutUser = async () => {
  let request = await useHttpRequest<{ success: boolean; message: string }>({
    url: "students/logout",
    method: "POST",
    showFullScreenLoader: true,
    loadingProperty: null,
    fullScreenLoaderMessage: "Logging you out...",
  });
  if (request && request.success && request.message == "LOGOUT_SUCCESSFUL") {
    store.commit("LOGOUT_USER");
    router.replace({ path: "/login" });
  }
};

const onLogoutIntent = async () => {
  closeNav();

  try {
    let logOut = await MessageBox.confirm(
      "You will be immediately logged out of your account, Continue?",
      "Confirm Log out",
      {
        confirmButtonText: "Logout",
        cancelButtonText: "Cancel",
        type: "warning",
      }
    );

    if (logOut) {
      logOutUser();
    }
  } catch (error) {
    // eslint-disable-line no-unused-vars
  }
};

return { __sfc: true,router, closeNav, logOutUser, onLogoutIntent, HomeIcon, FoldersIcon, VideoIcon, ClockIcon, BookOpenIcon, GraduationCapIcon, HourglassIcon, CoinsIcon, TelevisionIcon, CheckboxIcon, MessageIcon, EditIcon, SettingsIcon, LogoutIcon }
}

})